import { DEV } from '@/statics/environments';

export default {
  computed: {
    isDevelopment() {
      return process.env.VUE_APP_ENV === DEV;
    }
  }
};
